"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var getPaddingBySize = function (size) {
    switch (size) {
        case 'sm':
            return '1rem';
        case 'lg':
            return '3rem';
        case 'xl':
            return '4rem';
        default:
            return '2rem';
    }
};
var Padder = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", ";\n\n  & + & {\n    padding-top: 0;\n  }\n"], ["\n  padding: ", ";\n\n  & + & {\n    padding-top: 0;\n  }\n"])), function (_a) {
    var size = _a.size;
    return getPaddingBySize(size);
});
exports.default = Padder;
var templateObject_1;
